export const enabled = false;
export const firebaseConfig = null;
export const skitude_api_url = null;
export const skitude_api_key = null;
export const skitude_app_token = null;

const sso = {
   enabled,
   firebaseConfig,
   skitude_api_url,
   skitude_api_key,
   skitude_app_token,
};

export default sso;